export default __webpack_public_path__ + "static/media/Vector (2).d69e6d1d.svg";